import React from 'react';
import translate from "../../services/translation.json";
import "./calculatorTable.scss";
const CalculatorTable = ({data, type, lang ,curr}) => {
  const formatNumberWithCustomSeparator = (input) => {
    // Handle cases where the input is null, undefined, or an empty string
    if (input === null || input === undefined || input === "") {
      return "";
    }
  
    // Ensure the input is treated as a string to preserve all digits
    const numberString = input.toString();
  
    // Validate the input to ensure it's a valid number format
    if (!/^[-+]?\d*\.?\d*$/.test(numberString)) {
      throw new Error("Input must be a valid number or numeric string");
    }
  
    // Split the number into integer and decimal parts
    const [integerPart, decimalPart] = numberString.split(".");
  
    // Format the integer part with the custom separator
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  
    // Combine the formatted integer part with the decimal part (if it exists)
    return decimalPart !== undefined ? `${formattedInteger},${decimalPart}` : formattedInteger;
  };
  return (
    <div className='table-wrapper'>
      <h2 className='table-title'>{type}</h2>
      <table className='table'>
        <thead>
          <tr>
            <th>{translate[lang].calculator.year}</th>
            <th>{translate[lang].calculator.assets}</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(data).map((key, index) => (
            <tr key={index}>
              <td>{key}</td>
              <td className='price-column'><span className='table-currency'>{curr}</span> {`${formatNumberWithCustomSeparator(data[key])}`}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CalculatorTable;